import { Helmet } from 'react-helmet';
import { Session } from '../../../types/working-model';

interface Props {
	session: Session;
}

export default function SessionDocumentHead({ session }: Props): JSX.Element {
	return (
		<Helmet>
			{session.custom_css && (
				<style>
					{session.custom_css}
				</style>
			)}
		</Helmet>
	);
}